import { render } from "./Pre-EvaluationFrom.vue?vue&type=template&id=2daf96cd"
import script from "./Pre-EvaluationFrom.vue?vue&type=script&lang=js"
export * from "./Pre-EvaluationFrom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__